export const hostname = (new RegExp('locationone', 'i'))
  .test(window.location.hostname)
    ? 'locationone.com'
    : 'loisedapp.com';

export const endpoints = {
  local: {
    url: 'http://localhost:4730',
    arcUrl: 'https://services2.arcgis.com/g0Pkas6by3743iav/arcgis/rest/services',
    pdfUrl: 'http://localhost:4567',
    adminUrl: 'http://localhost:4200',
    lassoUrl: 'https://staging.lassoedapp.com',
    siteShepherdUrl: 'https://glswebappcert.azurewebsites.net/',
    buildingsEndPoint: '/buildings',
    buildingEndPoint: '/building',
    propertyPdfEndPoint: '/property',
    areaPdfEndPoint: '/area',
    exportFavoritesPdfEndpoint: '/export',
    favoritesListPdfEndpoint: '/list',
    sitesEndPoint: '/sites',
    siteEndPoint: '/site',
    businessesEndPoint: '/businesses',
    demographicsUrl: 'http://localhost:4730',
    demographicsEndPoint: '/demographics',
    workforceEndPoint: '/US_Zipcodes_lightcast/FeatureServer/0',
    demographicsLayersEndPoint: '/demographics/layer',
    areasEndPoint: '/areas',
    geoEndPoint: '/geo',
    organizationEndPoint: '/organization',
    viewerEndPoint: '/viewer',
    favoritesEndPoint: '/favorites',
    userProfileEndPoint: '/auth/profile',
    oAuthEndPoint: '/auth',
  },
  docker: {
    url: 'http://map.lois.local:4730',
    arcUrl: 'https://services2.arcgis.com/g0Pkas6by3743iav/arcgis/rest/services',
    pdfUrl: 'http://map.lois.local:4567',
    adminUrl: 'http://map.lois.local:4200',
    lassoUrl: 'https://staging.lassoedapp.com',
    siteShepherdUrl: 'https://glswebappcert.azurewebsites.net/',
    buildingsEndPoint: '/buildings',
    buildingEndPoint: '/building',
    propertyPdfEndPoint: '/property',
    areaPdfEndPoint: '/area',
    exportFavoritesPdfEndpoint: '/export',
    favoritesListPdfEndpoint: '/list',
    sitesEndPoint: '/sites',
    siteEndPoint: '/site',
    businessesEndPoint: '/businesses',
    demographicsUrl: 'http://map.lois.local:4730',
    demographicsEndPoint: '/demographics',
    workforceEndPoint: '/US_Zipcodes_lightcast/FeatureServer/0',
    demographicsLayersEndPoint: '/demographics/layer',
    areasEndPoint: '/areas',
    geoEndPoint: '/geo',
    organizationEndPoint: '/organization',
    viewerEndPoint: '/viewer',
    favoritesEndPoint: '/favorites',
    userProfileEndPoint: '/auth/profile',
    oAuthEndPoint: '/auth',
  },
  staging: {
    url: 'https://api.loised.com',
    arcUrl: 'https://services2.arcgis.com/g0Pkas6by3743iav/arcgis/rest/services',
    pdfUrl: 'https://pdf.loised.com',
    adminUrl: 'https://admin.loised.com',
    lassoUrl: 'https://staging.lassoedapp.com',
    siteShepherdUrl: 'https://glswebappcert.azurewebsites.net/',
    buildingsEndPoint: '/buildings',
    buildingEndPoint: '/building',
    propertyPdfEndPoint: '/property',
    areaPdfEndPoint: '/area',
    exportFavoritesPdfEndpoint: '/export',
    favoritesListPdfEndpoint: '/list',
    sitesEndPoint: '/sites',
    siteEndPoint: '/site',
    businessesEndPoint: '/businesses',
    demographicsUrl: 'https://api.loised.com',
    demographicsEndPoint: '/demographics',
    workforceEndPoint: '/US_Zipcodes_lightcast/FeatureServer/0',
    demographicsLayersEndPoint: '/demographics/layer',
    areasEndPoint: '/areas',
    geoEndPoint: '/geo',
    organizationEndPoint: '/organization',
    viewerEndPoint: '/viewer',
    favoritesEndPoint: '/favorites',
    userProfileEndPoint: '/auth/profile',
    oAuthEndPoint: '/auth',
  },
  production: {
    url: `https://api.${hostname}`,
    arcUrl: 'https://services2.arcgis.com/g0Pkas6by3743iav/arcgis/rest/services',
    pdfUrl: `https://pdf.${hostname}`,
    adminUrl: `https://admin.${hostname}`,
    lassoUrl: 'https://lassoedapp.com/',
    siteShepherdUrl: 'https://app.siteshepherd.com/',
    buildingsEndPoint: '/buildings',
    buildingEndPoint: '/building',
    propertyPdfEndPoint: '/property',
    areaPdfEndPoint: '/area',
    exportFavoritesPdfEndpoint: '/export',
    favoritesListPdfEndpoint: '/list',
    sitesEndPoint: '/sites',
    siteEndPoint: '/site',
    businessesEndPoint: '/businesses',
    demographicsUrl: `https://api.${hostname}`,
    demographicsEndPoint: '/demographics',
    workforceEndPoint: '/US_Zipcodes_lightcast/FeatureServer/0',
    demographicsLayersEndPoint: '/demographics/layer',
    areasEndPoint: '/areas',
    geoEndPoint: '/geo',
    organizationEndPoint: '/organization',
    viewerEndPoint: '/viewer',
    favoritesEndPoint: '/favorites',
    userProfileEndPoint: '/auth/profile',
    oAuthEndPoint: '/auth',
  },
};

export const esriDemographicsServer = 'https://demographics5.arcgis.com/arcgis/rest/services/USA_Demographics_and_Boundaries_2020/MapServer';

export const esriWorkforceServer = 'https://services2.arcgis.com/g0Pkas6by3743iav/arcgis/rest/services/US_Zipcodes_lightcast/FeatureServer/0';

export const esriDemographicZoomLayers = [
  {
    name: 'State',
    layer: 25,
    minZoom: 0,
    maxZoom: 6,
  },
  {
    name: 'DMA',
    layer: 38,
    minZoom: 7,
    maxZoom: 8,
  },
  {
    name: 'County',
    layer: 20,
    minZoom: 9,
    maxZoom: 9,
  },
  {
    name: 'Zip Code',
    layer: 14,
    minZoom: 10,
    maxZoom: 12,
  },
  {
    name: 'Block',
    layer: 4,
    minZoom: 13,
    maxZoom: 20,
  },
];

export const workforceMinZoom = 12;

export const esriAreaLayers = [
  {
    name: 'states',
    layer: 25,
  },
  {
    name: 'counties',
    layer: 20,
  },
  {
    name: 'regions',
    layer: 20,
  },
  {
    name: 'communities',
    layer: 39,
  },
];

export const railroads = {
  Amtrak: {
    url: 'amtrak',
    // color: '#0039A6',
    color: '#0573a6',
  },
  BNSF: {
    url: 'bnsf',
    // color: '#FF6319',
    color: '#e05e13',
  },
  'Canadian National': {
    url: 'canadiannational',
    // color: '#00AF3F',
    color: '#bf282e',
  },
  CPKC: {
    url: 'https://vectortileservices5.arcgis.com/ZDOOP2ZJddnpqvoa/arcgis/rest/services/CPKC_101_Network/VectorTileServer',
    // color: '#c2002f',
    color: '#c2002f',
  },
  CSX: {
    url: 'csxtransportation',
    // color: '#EE352E',
    // color: '#ffcb4f', // orig yellow
    // color: '#0451d0', // what Lisa suggested
    color: '#8132a8', // purple
  },
  'Norfolk Southern': {
    url: 'norfolksouthern',
    // color: '#006EC7',
    color: '#296b82',
  },
  OmniTRAX: {
    url: 'omnitrax',
    // color: '#ff0000',
    defaultOff: true,
    color: '#4c656c',
  },
  'Tulsa-Sapulpa': {
    url: 'tulsasapulpa',
    defaultOff: true,
    color: '#6CBE45',
  },
  'Union Pacific': {
    url: 'unionpacific',
    // color: '#00A1DE',
    color: '#d19900',
  },
  WATCO: {
    url: 'watco',
    // color: '#996633',
    defaultOff: true,
    color: '#ee7623',
  },
};

export const storage = {
  cloudStoragePath: 'https://media.loisedapp.com/files',
  distPath: 'https://media.loisedapp.com/dist',
  cloudFrontPath: 'https://media.loisedapp.com/files',
};

// New LOIS Key
export const API_KEY = 'AIzaSyCtMvqfQQ1_wxHM5ENI9TGrcqajCQAnd3A';



// WEBPACK FOOTER //
// ./src/config.js